module.exports = __webpack_public_path__ + "static/media/gr.ccd35d5b.svg";